"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var UserInfo_1 = require("../../user/model/UserInfo");
/**
 * @author ZSr
 * @author Tomas Leity
 */


var CoordinatorFlags =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CoordinatorFlags, _DomainObject_1$Domai);

  /**
   * @param coordinatorAgreed - after FC reviewed volume this is set to true, this parameter bypass one validation pass
   * @param coordinatorAgreedAt - after FC reviewed volume this sets a time of an agreed
   * @param coordinator - after FC reviewed volume this sets a time of an agreement
   * @param approvedPromoVolume - value of promo volume that was approved by coordinator
   * @param approvedSystemVolume
   * @param created - creation time of this object instance
   * @param createdBy - user that created this object instance
   */
  function CoordinatorFlags(coordinatorAgreed, coordinatorAgreedAt, coordinator, approvedPromoVolume, approvedSystemVolume, created, createdBy) {
    var _this;

    _classCallCheck(this, CoordinatorFlags);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CoordinatorFlags).call(this));
    _this.coordinatorAgreed = coordinatorAgreed;
    _this.coordinatorAgreedAt = coordinatorAgreedAt;
    _this.coordinator = coordinator;
    _this.approvedPromoVolume = approvedPromoVolume;
    _this.approvedSystemVolume = approvedSystemVolume;
    _this.created = created;
    _this.createdBy = createdBy;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(CoordinatorFlags, [{
    key: "reset",

    /**
     * <p>
     *  Resets existing {@link CoordinatorFlags} flag into initial state.
     * </p>
     *
     * @param createdBy {@link UserInfo} created by info
     */
    value: function reset(createdBy) {
      return CoordinatorFlags.create(createdBy);
    }
    /**
     * <p>
     *  Approves {@link CoordinatorFlags} flag parameters and sets required values.
     * </p>
     *
     * @param promoVolume Approved Promo volume
     * @param systemVolume Approved System volume
     * @param coordinator Info {@link UserInfo} about coordinator
     */

  }, {
    key: "approve",
    value: function approve(promoVolume, systemVolume, coordinator) {
      return this.copy('coordinatorAgreed', true).copy('coordinatorAgreedAt', moment()).copy('coordinator', coordinator).copy('approvedPromoVolume', promoVolume).copy('approvedSystemVolume', systemVolume);
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new CoordinatorFlags(mat.coordinatorAgreed, mat.coordinatorAgreedAt, mat.coordinator, mat.approvedPromoVolume, mat.approvedSystemVolume, mat.created, mat.createdBy);
    }
    /**
     * <p>
     *  Creates new instance of {@link CoordinatorFlags} and sets initial values.
     * </p>
     *
     * @param createdBy {@link UserInfo} created by info
     */

  }, {
    key: "create",
    value: function create(createdBy) {
      return new CoordinatorFlags(false, null, null, null, null, moment(), createdBy);
    }
  }]);

  return CoordinatorFlags;
}(DomainObject_1.DomainObject);

exports.CoordinatorFlags = CoordinatorFlags;

CoordinatorFlags.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CoordinatorFlags.name);
  return {
    coordinatorAgreed: builder.bool('coordinatorAgreed'),
    coordinatorAgreedAt: builder.opt(builder.date('coordinatorAgreedAt')),
    coordinator: builder.opt(builder.obj('coordinator', UserInfo_1.UserInfo.schema, function (mat) {
      return UserInfo_1.UserInfo.fromDataDict(mat);
    })),
    approvedPromoVolume: builder.opt(builder.bigNum('approvedPromoVolume')),
    approvedSystemVolume: builder.opt(builder.bigNum('approvedSystemVolume')),
    created: builder.date('created'),
    createdBy: builder.opt(builder.obj('createdBy', UserInfo_1.UserInfo.schema, function (mat) {
      return UserInfo_1.UserInfo.fromDataDict(mat);
    }))
  };
}();